import { Link } from "react-router-dom";

export default function CCCrossLink() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5361cd33910e73edfaab26cb110398dd.jpg"
          alt="Calm living room inspiration"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#FAF7F0]/80" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-8 md:px-16 flex flex-col md:flex-row md:items-center md:justify-between gap-12">
        <div className="max-w-lg">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Also from the Journal
          </p>
          <h2
            className="text-[#2C2825] text-3xl md:text-4xl lg:text-5xl leading-tight mb-5"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Want a wider<br />
            <em>room view?</em>
          </h2>
          <p
            className="text-[#6B5E53] text-sm md:text-base leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Browse calm living rooms with warm neutrals, soft textures, and open space.
          </p>
        </div>

        <Link
          to="/living-room"
          className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-9 py-4 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase flex-shrink-0"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Visit Living Rooms
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs" />
          </span>
        </Link>
      </div>
    </section>
  );
}
